import { Meta } from '@master/model/common/Meta'

export class CommissionStructureMeta extends Meta {
  pky: number = undefined
  receiverOid = ''
  cisPct: number = undefined
  giPct: number = undefined
  giRenewPct: number = undefined
  ebPct: number = undefined
  otherServicesPct: number = undefined
  lifePct: number = undefined
  loanPct: number = undefined
  paraPlanningPct: number = undefined
  level: number = undefined
}
